module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appearing main"
  }, [_c('div', {
    staticClass: "main-container white-background"
  }, [_c('div', {
    staticClass: "main-label black-color"
  }, [_vm._v("\n         Succès\n      ")]), _vm._v(" "), _c('p', [_vm._v("La connexion avec le compte Fitbit a été réalisée avec succès")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("Cliquer ici")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-001d267c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fitbit/FitbitAuthorized.vue
// module id = 1168
// module chunks = 1